import { Empresa } from './empresa.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class EmpresaService {

    constructor(private http: Http) {
    }

    getEmpresas(): Observable<Empresa[]> {
        return this.http.get(`${NTECH_API}/empresa`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/empresa/empresa.service.ts